import { BoostSkewFilterState, DEFAULT_BOOST_SKEW_FILTER_VALUE } from './boostSkew.types';

export const getDefaultBoostSkewFilter = (): BoostSkewFilterState => ({
  isBoostSkewed: DEFAULT_BOOST_SKEW_FILTER_VALUE,
});
export const defaultArtistsFilter = getDefaultBoostSkewFilter();
